import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OverlayPanelModule } from "primeng/primeng";
import { SearchOverlayComponent } from "./search-overlay.component";
import { SearchContentModule } from "../search-content/search-content.module";

@NgModule({
  imports: [CommonModule, OverlayPanelModule, SearchContentModule],
  declarations: [SearchOverlayComponent],
  exports: [SearchOverlayComponent, SearchContentModule]
})
export class SearchOverlayModule {}
